module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_mobile_45b90548e5b1da7c3d9c638b092c5687.png";